import React from "react";
import { Alert, Box, Checkbox, CircularProgress, FormControlLabel, Typography } from "@mui/material";
import { normalizeIdArray } from "../utils/companyUtils";
import { MaterialIcon } from "../../../utils/materialIcons";

export default function SectionAusstattungen({
                                                 form,
                                                 setForm,
                                                 amenities,
                                                 amenitiesLoading,
                                                 amenitiesError,
                                             }) {
    const selectedIds = normalizeIdArray(form.amenity_ids);

    const toggleAmenity = (id) => {
        setForm((f) => {
            const ids = new Set(normalizeIdArray(f.amenity_ids));
            if (ids.has(id)) ids.delete(id);
            else ids.add(id);
            return { ...f, amenity_ids: Array.from(ids).sort((a, b) => a - b) };
        });
    };

    if (amenitiesError) {
        return <Alert severity="error">{amenitiesError}</Alert>;
    }

    if (amenitiesLoading) {
        return (
            <Box sx={{ py: 2, textAlign: "center" }}>
                <CircularProgress size={20} />
            </Box>
        );
    }

    if (!amenities?.length) {
        return <Alert severity="info">Keine Ausstattungen vorhanden. Lege zuerst Ausstattungen an.</Alert>;
    }

    return (
        <Box>
            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }}>
                {selectedIds.length} von {amenities.length} ausgewählt
            </Typography>

            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(2, minmax(0, 1fr))",
                        md: "repeat(3, minmax(0, 1fr))",
                        lg: "repeat(4, minmax(0, 1fr))",
                    },
                    gap: 0.25,
                    maxHeight: 320,
                    overflowY: "auto",
                    pr: 1,
                    py: 0.5,
                }}
            >
                {amenities.map((amenity) => {
                    const id = Number(amenity.id);
                    const checked = selectedIds.includes(id);
                    const label = amenity.label_de || amenity.name;

                    return (
                        <FormControlLabel
                            key={amenity.id}
                            control={
                                <Checkbox
                                    size="small"
                                    checked={checked}
                                    onChange={() => toggleAmenity(id)}
                                    sx={{ py: 0.5 }}
                                />
                            }
                            label={<Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                                <MaterialIcon iconName={amenity.icon_name} />
                                <Box component="span" sx={{ overflow: "hidden", textOverflow: "ellipsis" }}>{label}</Box>
                            </Box>}
                            sx={{
                                m: 0,
                                minWidth: 0,
                                borderRadius: 1,
                                px: 0.75,
                                py: 0.25,
                                bgcolor: checked ? "rgba(240, 172, 77, 0.10)" : "transparent",
                                "&:hover": { bgcolor: "action.hover" },
                                "& .MuiFormControlLabel-label": {
                                    fontSize: "0.875rem",
                                    lineHeight: 1.25,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                },
                            }}
                        />
                    );
                })}
            </Box>
        </Box>
    );
}
